import { createFileRoute } from '@tanstack/react-router';
import { MockExamsPage } from '@/features/mockExams/admin/MockExamsPage';
export const Route = createFileRoute('/_authed/admin/mock-exams/')({ component: MockExamsPage });
